var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { Component, Vue, Watch, Prop } from "vue-facing-decorator";
import { Feature, SystemsClient, SettingsClient, CompaniesClient, SitesClient, SystemComponentsClient, SystemTrendClient, SystemAccessQueryModel, GetOhmicTrendPDFReportQuery, ReportScheduleModel, BatteryTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
import moment from 'moment';
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const componentClient = new SystemComponentsClient(window.apiUrl);
const systemTrendClient = new SystemTrendClient(window.apiUrl);
const settingsClient = new SettingsClient(window.apiUrl);
let OhmicTrendReportFilterVue = class OhmicTrendReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.displayAdvancedFilter = false;
        this.companies = [];
        this.sites = [];
        this.companyId = null;
        this.siteId = null;
        this.selectedSystem = new SystemAccessQueryModel();
        this.systems = new Array();
        this.startTime = new Date();
        this.endTime = new Date();
        this.dateFilterOptions = ["Y", "2Y", "All", "..."];
        this.dateFilterOption = "";
        this.defaultDateFilterOption = "Y";
        this.periodType = 1; // 1 - Baseline to latest reading, 2 - Period
        this.totalOhmicRiseLimit = 50;
        this.quarterOhmicRiseLimit = 10;
        this.fourWeeksOhmicRiseLimit = 5;
        this.hidePredictionColumn = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.stringsList = [];
    }
    created() {
        this.getLookups();
        if (this.loginState.isPowerShield) {
            this.dateFilterOptions = ["Prev M", ...this.dateFilterOptions];
            this.defaultDateFilterOption = "Prev M";
        }
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    /**
    * Retrieve all lookups used by the form.
    * */
    getLookups() {
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [
                systemsClient
                    .getSystems(false, Feature.Report_OhmicTrend)
                    .then(response => {
                    if (!response)
                        return;
                    // The placeholder is not an option: a filter always needs a real system (CLD-1300)
                    this.systems = response;
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                companyClient
                    .getListGET()
                    .then(response => {
                    let companies = (response || []).map((item) => {
                        return {
                            value: item.companyId,
                            text: item.companyName || ""
                        };
                    });
                    this.companies = [{ value: null, text: `All companies` }].concat(companies);
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
                    .finally(() => {
                }),
                siteClient
                    .getListForUser()
                    .then(response => {
                    this.sites = response;
                })
            ];
            return yield Promise.all(promises).then(() => {
                if (this.reportScheduledModel)
                    this.loadReportScheduleQuery(false);
            });
        });
    }
    ;
    setDefaultDates() {
        return __awaiter(this, void 0, void 0, function* () {
            let start = null;
            let end = null;
            let now = new Date();
            end = moment(now.toISOString()).endOf("day").toDate();
            if (this.periodType == 1) {
                start = moment(now.toISOString()).add(-12 * 7, "days").startOf("day").toDate();
                this.startTime = start;
                this.endTime = end;
                return;
            }
            if (this.dateFilterOption == "...")
                return;
            switch (this.dateFilterOption) {
                case "Prev M":
                    var dateRange = DateHelper.getDateRange(DatePresetOption.PrevMonth);
                    start = dateRange.start;
                    end = dateRange.end;
                    break;
                case "Y":
                    start = moment(now.toISOString()).add(-1, "years").startOf("day").toDate();
                    break;
                case "2Y":
                    start = moment(now.toISOString()).add(-2, "years").startOf("day").toDate();
                    break;
            }
            this.startTime = start;
            this.endTime = end;
        });
    }
    ;
    onCompanyIdChanged() {
        var _a;
        var site = this.sites.find(site => site.siteId == this.siteId);
        if (this.companyId != (site === null || site === void 0 ? void 0 : site.companyId))
            this.siteId = null;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.companyId) != this.companyId)
            this.selectedSystem = new SystemAccessQueryModel();
    }
    onSiteIdChanged() {
        var _a;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.siteId) != this.siteId)
            this.selectedSystem = new SystemAccessQueryModel();
    }
    getSystemStringsAndParameters() {
        var _a, _b, _c;
        if (!((_a = this.selectedSystem) === null || _a === void 0 ? void 0 : _a.systemId)) {
            this.stringsList = [];
            return;
        }
        let promises = [
            settingsClient.getOhmicTrendReportSettingsForSystem((_b = this.selectedSystem) === null || _b === void 0 ? void 0 : _b.systemId),
            componentClient
                .getSystemStrings((_c = this.selectedSystem) === null || _c === void 0 ? void 0 : _c.systemId)
                .then(response => {
                this.stringsList = response.map(item => {
                    return {
                        value: item.componentId,
                        text: item.componentName || "",
                        selected: true
                    };
                });
            })
        ];
        Promise.all(promises)
            .then((values) => {
            var _a;
            if (this.reportScheduledModel)
                this.loadReportScheduleQuery(true);
            else {
                let settings = values[0];
                if ((_a = settings === null || settings === void 0 ? void 0 : settings.stringIds) === null || _a === void 0 ? void 0 : _a.length) {
                    this.stringsList.forEach(item => { var _a; return item.selected = ((_a = settings.stringIds) === null || _a === void 0 ? void 0 : _a.includes(item.value)) || false; });
                }
                this.totalOhmicRiseLimit = (settings === null || settings === void 0 ? void 0 : settings.totalOhmicRiseLimit) || this.totalOhmicRiseLimit;
                this.quarterOhmicRiseLimit = (settings === null || settings === void 0 ? void 0 : settings.quarterOhmicRiseLimit) || this.quarterOhmicRiseLimit;
                this.fourWeeksOhmicRiseLimit = (settings === null || settings === void 0 ? void 0 : settings.fourWeeksOhmicRiseLimit) || this.fourWeeksOhmicRiseLimit;
            }
        });
    }
    ;
    get selectPlaceholderSystem() {
        return "Please select a System";
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
    get systemsFiltered() {
        var filteredSystems = this.systems
            .filter(system => {
            var _a;
            return (((_a = system.batteryTypeId) !== null && _a !== void 0 ? _a : 1) == BatteryTypeEnum.LeadAcid) && (!this.companyId || system.companyId == this.companyId) && (!this.siteId || system.siteId == this.siteId);
        });
        return filteredSystems;
    }
    get system() {
        return this.systems.filter(item => {
            var _a;
            return ((_a = this.selectedSystem) === null || _a === void 0 ? void 0 : _a.systemId) && item.systemId == this.selectedSystem.systemId;
        })[0];
    }
    ;
    set system(item) {
        this.selectedSystem = item;
    }
    ;
    get isSystemInvalid() {
        return (!this.selectedSystem || !this.selectedSystem.systemId) && this.searchAttempted;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    get areDatesInvalid() {
        if (!this.startTime || !this.endTime)
            return false;
        let startTime = DateHelper.convertToDate(this.startTime.toString());
        let endTime = DateHelper.convertToDate(this.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    get numberOfSelectedStringToExport() {
        return this.stringsList.filter(string => string.selected).length;
    }
    ;
    get stringToExportOptionText() {
        var _a;
        if (this.numberOfSelectedStringToExport == this.stringsList.length)
            return `All strings`;
        if (this.numberOfSelectedStringToExport != 1)
            return `${this.stringsList.filter(string => string.selected).length} strings selected`;
        return (_a = this.stringsList.filter(string => string.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
    }
    ;
    getQuery() {
        this.searchAttempted = true;
        if (this.working || this.isSystemInvalid || this.areDatesInvalid) {
            return null;
        }
        let startTime = moment(this.startTime);
        let endTime = moment(this.endTime).endOf("day");
        if (endTime.diff(startTime, 'days') < 14) {
            Notifier.onWarning("Select at least 2 weeks!");
            return null;
        }
        let stringIds = this.stringsList.filter(x => x.selected).map(x => x.value);
        if (!stringIds.length) {
            Notifier.onWarning("Select at least one String for the report!");
            return null;
        }
        var timezoneOffset = moment().utcOffset();
        let reportQuery = new GetOhmicTrendPDFReportQuery({
            timezoneOffset: timezoneOffset,
            systemId: this.system.systemId,
            startDate: this.startTime == null ? null : startTime.toDate(),
            isDefaultPeriod: this.periodType == 1,
            endDate: this.endTime == null ? null : endTime.toDate(),
            stringIds: stringIds,
            totalOhmicRiseLimit: this.totalOhmicRiseLimit,
            quarterOhmicRiseLimit: this.quarterOhmicRiseLimit,
            fourWeeksOhmicRiseLimit: this.fourWeeksOhmicRiseLimit,
            hidePredictionColumn: this.hidePredictionColumn
        });
        return reportQuery;
    }
    generateOhmicTrendReport() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        this.working = true;
        systemTrendClient.downloadOhmicTrendReportAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download the report.");
                return;
            }
            //DownloadUtil.handleFileDownload(response);
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryWithPeriod = Object.assign(Object.assign({}, reportQuery), { dateFilterOption: this.dateFilterOption });
        var queryString = JSON.stringify(queryWithPeriod);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    loadReportScheduleQuery(stringsLoaded = false) {
        var _a, _b, _c;
        if (!((_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query))
            return;
        var queryString = (_b = this.reportScheduledModel) === null || _b === void 0 ? void 0 : _b.query;
        this.working = true;
        try {
            var query = JSON.parse(queryString);
            if (!stringsLoaded) {
                var system = (_c = this.systems.find(item => item.systemId == query.systemId)) !== null && _c !== void 0 ? _c : new SystemAccessQueryModel();
                this.companyId = system === null || system === void 0 ? void 0 : system.companyId;
                this.siteId = system === null || system === void 0 ? void 0 : system.siteId;
                this.system = system;
            }
            else {
                this.totalOhmicRiseLimit = query.totalOhmicRiseLimit;
                this.quarterOhmicRiseLimit = query.quarterOhmicRiseLimit;
                this.fourWeeksOhmicRiseLimit = query.fourWeeksOhmicRiseLimit;
                this.periodType = query.isDefaultPeriod ? 1 : 2;
                this.hidePredictionColumn = query.hidePredictionColumn || false;
                if (query.dateFilterOption) {
                    this.setDateFilterOption(query.dateFilterOption);
                    // If custom dates were selected ("..."), restore the exact dates from the query
                    if (query.dateFilterOption === "...") {
                        if (query.startDate) {
                            this.startTime = DateHelper.convertToDate(query.startDate);
                        }
                        if (query.endDate) {
                            this.endTime = DateHelper.convertToDate(query.endDate);
                        }
                    }
                }
                else {
                    let startTime = query.startDate;
                    let endTime = query.endDate;
                    if (startTime && endTime) {
                        var duration = moment.duration(moment(endTime).diff(moment(startTime)));
                        var days = duration.asDays();
                        if (days < 90)
                            this.setDateFilterOption("12 Weeks");
                        else if (days < 370)
                            this.setDateFilterOption("Y");
                        else if (days < 735)
                            this.setDateFilterOption("2Y");
                        else
                            this.setDateFilterOption("All");
                    }
                    else {
                        this.setDateFilterOption("All");
                    }
                }
                this.stringsList.forEach(item => item.selected = query.stringIds.indexOf(item.value) >= 0);
            }
        }
        catch (ex) {
            console.error(ex);
        }
        finally {
            this.working = false;
        }
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], OhmicTrendReportFilterVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _b : Object)
], OhmicTrendReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("periodType"),
    Watch("dateFilterOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], OhmicTrendReportFilterVue.prototype, "setDefaultDates", null);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OhmicTrendReportFilterVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OhmicTrendReportFilterVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("selectedSystem"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OhmicTrendReportFilterVue.prototype, "getSystemStringsAndParameters", null);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OhmicTrendReportFilterVue.prototype, "onReportScheduledModelChanged", null);
OhmicTrendReportFilterVue = __decorate([
    Component({
        name: "OhmicTrendReportFilterVue",
        emits: ["schedule", "updateSchedule"]
    })
], OhmicTrendReportFilterVue);
export default OhmicTrendReportFilterVue;
